import { memo } from 'react'

import formatSlotDate from '@/helpers/formatSlotDate'
import { addProductToCart } from '@/store/slices/cart'
import Product, { ProductTimeSlot } from '@/ts/Product'

import PickButton from './includes/PickButton'

function TimeSlot({ product, slot }: TimeSlotProps) {
  const participantsNumber = slot.participants_number.aggregate.count
  const isSoldOut = participantsNumber >= product.max_participants

  const { eventDate, timeframe } = formatSlotDate(slot.date, product.duration)

  const pickSlot = () => addProductToCart({ ...product, time_slot_id: slot.id })

  return (
    <div className="flex flex-col items-center justify-between space-y-2 text-sm 3xs:flex-row 3xs:space-y-0">
      <div className="flex flex-col flex-shrink-0">
        <time>{eventDate}</time>
        <time className="text-sm text-black/60">{timeframe}</time>
      </div>
      <PickButton onClick={pickSlot} isDisabled={isSoldOut} />
    </div>
  )
}

interface TimeSlotProps {
  product: Product
  slot: ProductTimeSlot
}

export default memo(TimeSlot)
